import { Divider, Layout, Space, Typography } from "antd";

const { Text, Title } = Typography;
const { Content } = Layout;

export default function PrivacyPolicy() {
  return (
    <div className="Privacy_Policy">
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ padding: "24px" }}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <Title level={1}>Privacy Policy</Title>
            <Divider />
            <Text>
              This privacy policy explains how we collect, use, and protect your information when you use our
              software. Our platform provides innovative solutions to help you achieve your goals with efficiency
              and accuracy.
            </Text>
            <Title level={2}>Personal Information the App Collects</Title>
            <Text>
              We collect the following types of personal information from you: user details, account information
              and activity details about you and others who may access the software on behalf of you, such as your
              name, address, email address, phone number, and billing information.
            </Text>
            <Title level={2}>Usage of Personal Information</Title>
            <Text>
              We use the personal information gathered from you is utilized solely for delivering our service and
              maintaining software operations. Additionally, we may share this information to adhere to pertinent
              laws and regulations, respond to legal requests such as subpoenas or search warrants, or safeguard
              our rights. Rest assured, your data is handled with the utmost care and in strict compliance with
              legal standards.
            </Text>
            <Title level={2}>Data Retention</Title>
            <Text>
              when activities are conducted through our software, we retain the related information for our
              records. This data will be securely maintained unless and until you request its deletion. Your
              privacy and control over your information are of utmost importance to us, and we are committed to
              ensuring that your data is handled responsibly and in accordance with your preferences.
            </Text>
            <Title level={2}>Changes to Privacy Policy</Title>
            <Text>
              We may update this privacy policy from time to time to reflect changes to our practices or for other
              operational, legal, or regulatory reasons.
            </Text>
            <Title level={2}>Contact Us</Title>
            <Text>
              For more information about our privacy practices, if you have questions, or if you would like to make
              a complaint, please contact us by e-mail at hello@webrexstudio.com or by mail using the details
              provided below:
            </Text>
            <Text>209, Saumya Square near Goverdhan party plot, Thaltej 380052, Ahmedabad, India.</Text>
          </Space>
        </Content>
      </Layout>
    </div>
  );
}
